export function Stat({ label, value, sub, variant }: {
  label: string;
  value: number | string;
  sub?: string;
  variant?: 'alert' | 'warn';
}) {
  return (
    <div className={`stat ${variant ?? ''}`}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {sub && <div className="stat-sub">{sub}</div>}
    </div>
  );
}
